<br />
<br />
<br />

<div id="footer" *ngIf="isAuthenticated">
  <div style="text-align: center;">
    <a [routerLink]='["/"]'>Home</a>
    <a [routerLink]='["/allscores"]'>All Standings</a>
    <a [routerLink]='["/history"]'>History</a>
    <a [routerLink]='["/authentication/profile"]'>Edit Profile</a>
    <a [routerLink]='["/authentication/logout"]' [state]='{ local: true }'>Logout</a>
  </div>
  <div style="text-align: center;"><a href="#" (click)="msgDialog($event)">Out of town? Injured?</a></div>
</div>

<div style="height: 100px;"></div>
<div *ngIf="playerId == 'acfc2497-cb44-4394-b866-3f546b306ff6' || playerId == '074e9283-ff17-49c1-b6f8-787d11dad581'">
  <a href="#" (click)="clearImpersonte($event)">Clear Impersonate</a>
  <br /><br />
  <a [routerLink]='["/admin/impersonate"]'>Impersonate</a>
  <br /><br />
  <a [routerLink]='["/admin/paid"]'>Mark Paid / Drop Player</a>
  <br /><br />
  <a [routerLink]='["/admin/email"]'>Email Players</a>

  <br /><br />
  <a [routerLink]='["/admin/pairing"]'>Pairing</a>
  <br /><br />
  <a [routerLink]='["/admin/pairdoubles"]'>Pair DOUBLES</a>
  <br /><br />
  <a [routerLink]='["/admin/setrank"]'>Set Rank</a>
  <br /><br />
  <a [routerLink]='["/admin/record"]'>Record Any Match</a>
  <br /><br />
  <a [routerLink]='["/admin/tourney"]'>Create Tournaments</a>
  <br /><br />
  <a [routerLink]='["/admin/printplayers"]'>Print Player List</a>
  <br /><br />
  <a [routerLink]='["/admin/bookreservation"]'>Book Reservation</a>
  <br /><br />
  <a [routerLink]='["/admin/stripelookup"]'>Stripe Lookup</a>
  <br /><br />
  <a [routerLink]='["/admin/ladder-management"]'>Manage Ladders</a>
  <br /><br />
</div>
<!-- -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= -->
<!-- <div style="font-weight: bold; color: #990000; margin: 20px;">
  <hr />
  Be safe! We are not telling you when, where or how to play. You play at your own risk.
  You must follow all local, state, and federal guidelines regarding COVID-19.
  If you feel sick, or were exposed to anyone with COVID-19, cancel and postpone your match.
  <hr />
</div> -->
<!-- -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= -->
<footer class="footer border-top text-muted">
  <div class="container"> Boca Tennis Ladder is a service of elubin.com, inc.
    — <a href="#" (click)="privacyDialog($event)">Privacy Policy</a></div>
  <div class="container">
    23401 Boca Chica Circle, Boca Raton, FL 33433
  </div>
  <div class="container">
    &copy; 2020-{{ currentYear }}
  </div>
  <div style="min-height: 100px"></div>
</footer>
